import * as React from 'react';
import { cn } from '@/lib/utils';

export interface PageHeaderProps {
  /** Small mono caption above the title (`.dc-eyebrow`). */
  eyebrow?: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  /** Slot on the right, usually a Button. */
  action?: React.ReactNode;
  className?: string;
}

/**
 * Page header after the reference design: eyebrow, display title as the
 * page's `h1`, an optional line of copy and an action slot on the right.
 * Optional parts render no element at all when absent.
 */
export function PageHeader({
  eyebrow,
  title,
  description,
  action,
  className,
}: PageHeaderProps) {
  return (
    <header
      className={cn(
        'flex flex-wrap items-end justify-between gap-x-6 gap-y-4',
        className
      )}
    >
      <div className="min-w-0 space-y-2">
        {eyebrow && <p className="dc-eyebrow">{eyebrow}</p>}
        <h1 className="dc-h1 text-[28px] text-ink sm:text-[32px]">{title}</h1>
        {description && (
          <p className="max-w-prose text-sm text-ink-2">{description}</p>
        )}
      </div>
      {action && (
        <div className="flex shrink-0 items-center gap-2">{action}</div>
      )}
    </header>
  );
}
